<div class="border-end pe-3 me-3">
  <div class="d-flex align-items-center" ngbDropdown #dropdown="ngbDropdown">
    <button 
      class="btn btn-secondary dropdown-toggle d-flex p-1 align-items-center justify-content-center" 
      id="orderListsViewDropdown" 
      ngbDropdownToggle
      type="button"
      #tooltip="ngbTooltip"
      [ngbTooltip]="tooltipContent"
      [disableTooltip]="popover.isOpen() || dropdown.isOpen()"
      container="body"
      placement="bottom-left"
      popoverClass="shadow"
      triggers="mouseenter:mouseleave"
      (click)="tooltip.close()"
    >
      <i class="icon"
        [class.ni-document]="activeOrderListsViewType === orderListsViewTypeEnum.ORDERS_MANAGEMENT"
        [class.ni-shipping]="activeOrderListsViewType === orderListsViewTypeEnum.LOGISTICS"
        #popover="ngbPopover"
        [ngbPopover]="popoverContent"
        placement="bottom start"
        [autoClose]="false"
        popoverClass="mw-100 rounded-1 shadow-sm"
        container="body"
        [popperOptions]="introPopperOptions"
        triggers="manual"
      ></i>
    </button>
    <div ngbDropdownMenu class="dropdown-menu p-0 shadow" [attr.aria-labelledby]="'orderListsViewDropdown'">
      <button
        class="d-flex align-items-center btn btn-secondary border-bottom"
        ngbDropdownItem 
        (click)="switchOrdersView(orderListsViewTypeEnum.ORDERS_MANAGEMENT)"
        type="button"
      >
        <i class="icon ni-document me-2"></i>
        <span class="text-truncate">{{ 'ORDERS.VIEWS.MANAGEMENT' | translate }}</span>
      </button>
      <button
        class="d-flex align-items-center btn btn-secondary"
        ngbDropdownItem 
        (click)="switchOrdersView(orderListsViewTypeEnum.LOGISTICS)"
        type="button"
      >
        <i class="icon ni-shipping me-2"></i>
        <span class="text-truncate">{{ 'ORDERS.VIEWS.LOGISTICS' | translate }}</span>
      </button>
    </div>
  </div>
</div>

<ng-template #popoverContent>
  <div class="d-flex flex-column gap-3" [style.width.px]="280">
    <h4 class="m-0">{{ 'ORDERS.VIEWS_SWITCH_INTRO.TITLE' | translate }}</h4>
    <div>{{ 'ORDERS.VIEWS_SWITCH_INTRO.DESCRIPTION' | translate }}</div>
    <button type="button" (click)="onDontShowAgain()" class="btn btn-primary">
      {{ "ACTIONS.UNDERSTOOD" | translate }}
    </button>
  </div>
</ng-template>

<ng-template #tooltipContent>
  <div class="text-pre-wrap text-left" [style.width.px]="140" >{{ 'ORDERS.VIEW_TOOLTIP' | translate }}</div>
</ng-template>
